webpackJsonp([114276838955818,60335399758886],{

/***/ 131:
/***/ (function(module, exports) {

	module.exports = {"data":{"datoCmsMenu":{"logo":{"url":"https://www.datocms-assets.com/3639/1530287924-megahouse-logo.svg","resolutions":null}},"datoCmsSite":{"faviconMetaTags":{"tags":[{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"57x57","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=57&w=57","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"60x60","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=60&w=60","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"72x72","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=72&w=72","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"76x76","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=76&w=76","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"114x114","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=114&w=114","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"120x120","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=120&w=120","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"144x144","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=144&w=144","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"152x152","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=152&w=152","name":null,"content":null,"type":null}},{"tagName":"link","attributes":{"rel":"apple-touch-icon","sizes":"180x180","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=180&w=180","name":null,"content":null,"type":null}},{"tagName":"meta","attributes":{"rel":null,"sizes":null,"href":null,"name":"msapplication-square70x70","content":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=70&w=70","type":null}},{"tagName":"meta","attributes":{"rel":null,"sizes":null,"href":null,"name":"msapplication-square150x150","content":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=150&w=150","type":null}},{"tagName":"meta","attributes":{"rel":null,"sizes":null,"href":null,"name":"msapplication-square310x310","content":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=310&w=310","type":null}},{"tagName":"meta","attributes":{"rel":null,"sizes":null,"href":null,"name":"msapplication-square310x150","content":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=150&w=310","type":null}},{"tagName":"link","attributes":{"rel":"icon","sizes":"16x16","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=16&w=16","name":null,"content":null,"type":"image/png"}},{"tagName":"link","attributes":{"rel":"icon","sizes":"32x32","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=32&w=32","name":null,"content":null,"type":"image/png"}},{"tagName":"link","attributes":{"rel":"icon","sizes":"96x96","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=96&w=96","name":null,"content":null,"type":"image/png"}},{"tagName":"link","attributes":{"rel":"icon","sizes":"192x192","href":"https://www.datocms-assets.com/3639/1517182131-mh-logo.png?h=192&w=192","name":null,"content":null,"type":"image/png"}},{"tagName":"meta","attributes":{"rel":null,"sizes":null,"href":null,"name":"application-name","content":"Mega House Creative","type":null}}]}}},"layoutContext":{}}

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(258);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(131);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(465)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowequal = __webpack_require__(237);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _raf = __webpack_require__(469);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldUpdate2 = __webpack_require__(534);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved
	
	
	var noop = function noop() {};
	
	var Headroom = function (_Component) {
	  _inherits(Headroom, _Component);
	
	  function Headroom(props) {
	    _classCallCheck(this, Headroom);
	
	    // Class variables.
	    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));
	
	    _this.setRef = function (ref) {
	      return _this.inner = ref;
	    };
	
	    _this.setHeightOffset = function () {
	      _this.setState({
	        height: _this.inner.offsetHeight
	      });
	      _this.resizeTicking = false;
	    };
	
	    _this.getScrollY = function () {
	      if (_this.props.parent().pageYOffset !== void 0) {
	        return _this.props.parent().pageYOffset;
	      } else if (_this.props.parent().scrollTop !== void 0) {
	        return _this.props.parent().scrollTop;
	      } else {
	        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      }
	    };
	
	    _this.getViewportHeight = function () {
	      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	    };
	
	    _this.getDocumentHeight = function () {
	      var body = document.body;
	      var documentElement = document.documentElement;
	
	      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
	    };
	
	    _this.getElementPhysicalHeight = function (elm) {
	      return Math.max(elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getElementHeight = function (elm) {
	      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getScrollerPhysicalHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
	    };
	
	    _this.getScrollerHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
	    };
	
	    _this.isOutOfBound = function (currentScrollY) {
	      var pastTop = currentScrollY < 0;
	
	      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
	      var scrollerHeight = _this.getScrollerHeight();
	
	      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;
	
	      return pastTop || pastBottom;
	    };
	
	    _this.handleScroll = function () {
	      if (!_this.scrollTicking) {
	        _this.scrollTicking = true;
	        (0, _raf2.default)(_this.update);
	      }
	    };
	
	    _this.handleResize = function () {
	      if (!_this.resizeTicking) {
	        _this.resizeTicking = true;
	        (0, _raf2.default)(_this.setHeightOffset);
	      }
	    };
	
	    _this.unpin = function () {
	      _this.props.onUnpin();
	
	      _this.setState({
	        translateY: '-100%',
	        className: 'headroom headroom--unpinned'
	      }, function () {
	        setTimeout(function () {
	          _this.setState({ state: 'unpinned' });
	        }, 0);
	      });
	    };
	
	    _this.pin = function () {
	      _this.props.onPin();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--pinned',
	        state: 'pinned'
	      });
	    };
	
	    _this.unfix = function () {
	      _this.props.onUnfix();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--unfixed',
	        state: 'unfixed'
	      });
	    };
	
	    _this.update = function () {
	      _this.currentScrollY = _this.getScrollY();
	
	      if (!_this.isOutOfBound(_this.currentScrollY)) {
	        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
	            action = _shouldUpdate.action;
	
	        if (action === 'pin') {
	          _this.pin();
	        } else if (action === 'unpin') {
	          _this.unpin();
	        } else if (action === 'unfix') {
	          _this.unfix();
	        }
	      }
	
	      _this.lastKnownScrollY = _this.currentScrollY;
	      _this.scrollTicking = false;
	    };
	
	    _this.currentScrollY = 0;
	    _this.lastKnownScrollY = 0;
	    _this.scrollTicking = false;
	    _this.resizeTicking = false;
	    _this.state = {
	      state: 'unfixed',
	      translateY: 0,
	      className: 'headroom headroom--unfixed'
	    };
	    return _this;
	  }
	
	  _createClass(Headroom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setHeightOffset();
	      if (!this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disable && !this.props.disable) {
	        this.unfix();
	        this.props.parent().removeEventListener('scroll', this.handleScroll);
	        this.props.parent().removeEventListener('resize', this.handleResize);
	      } else if (!nextProps.disable && this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // If children have changed, remeasure height.
	      if (prevProps.children !== this.props.children) {
	        this.setHeightOffset();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.parent().removeEventListener('scroll', this.handleScroll);
	      window.removeEventListener('scroll', this.handleScroll);
	      this.props.parent().removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userClassName = _props.className,
	          divProps = _objectWithoutProperties(_props, ['className']);
	
	      delete divProps.onUnpin;
	      delete divProps.onPin;
	      delete divProps.onUnfix;
	      delete divProps.disableInlineStyles;
	      delete divProps.disable;
	      delete divProps.parent;
	      delete divProps.children;
	      delete divProps.upTolerance;
	      delete divProps.downTolerance;
	      delete divProps.pinStart;
	      delete divProps.calcHeightOnResize;
	
	      var style = divProps.style,
	          wrapperStyle = divProps.wrapperStyle,
	          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);
	
	      var innerStyle = {
	        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        zIndex: 1,
	        WebkitTransform: 'translateY(' + this.state.translateY + ')',
	        MsTransform: 'translateY(' + this.state.translateY + ')',
	        transform: 'translateY(' + this.state.translateY + ')'
	      };
	
	      var className = this.state.className;
	
	      // Don't add css transitions until after we've done the initial
	      // negative transform when transitioning from 'unfixed' to 'unpinned'.
	      // If we don't do this, the header will flash into view temporarily
	      // while it transitions from 0 — -100%.
	      if (this.state.state !== 'unfixed') {
	        innerStyle = _extends({}, innerStyle, {
	          WebkitTransition: 'all .2s ease-in-out',
	          MozTransition: 'all .2s ease-in-out',
	          OTransition: 'all .2s ease-in-out',
	          transition: 'all .2s ease-in-out'
	        });
	        className += ' headroom--scrolled';
	      }
	
	      if (!this.props.disableInlineStyles) {
	        innerStyle = _extends({}, innerStyle, style);
	      } else {
	        innerStyle = style;
	      }
	
	      var wrapperStyles = _extends({}, wrapperStyle, {
	        height: this.state.height ? this.state.height : null
	      });
	
	      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { style: wrapperStyles, className: wrapperClassName },
	        _react2.default.createElement(
	          'div',
	          _extends({
	            ref: this.setRef
	          }, rest, {
	            style: innerStyle,
	            className: className
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Headroom;
	}(_react.Component);
	
	Headroom.propTypes = {
	  className: _propTypes2.default.string,
	  parent: _propTypes2.default.func,
	  children: _propTypes2.default.any.isRequired,
	  disableInlineStyles: _propTypes2.default.bool,
	  disable: _propTypes2.default.bool,
	  upTolerance: _propTypes2.default.number,
	  downTolerance: _propTypes2.default.number,
	  onPin: _propTypes2.default.func,
	  onUnpin: _propTypes2.default.func,
	  onUnfix: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  pinStart: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  calcHeightOnResize: _propTypes2.default.bool
	};
	Headroom.defaultProps = {
	  parent: function parent() {
	    return window;
	  },
	  disableInlineStyles: false,
	  disable: false,
	  upTolerance: 5,
	  downTolerance: 0,
	  onPin: noop,
	  onUnpin: noop,
	  onUnfix: noop,
	  wrapperStyle: {},
	  pinStart: 0,
	  calcHeightOnResize: true
	};
	exports.default = Headroom;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
	  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
	  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
	
	  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
	  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);
	
	  // We're disabled
	  if (props.disable) {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're at the top and not fixed yet.
	  } else if (currentScrollY <= props.pinStart && state.state !== 'unfixed') {
	    return {
	      action: 'unfix',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're unfixed and headed down. Carry on.
	  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're past the header and scrolling down.
	    // We transition to "unpinned" if necessary.
	  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart && distanceScrolled > props.downTolerance) {
	    return {
	      action: 'unpin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, we transition to "pinned"
	  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	    // We're scrolling up, and inside the header.
	    // We transition to pin regardless of upTolerance
	  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  } else {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  }
	};

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/frill.7be7c374.png";

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  #contact {\n    background-image: url(', ');\n    background-position: bottom;\n    background-repeat: repeat-x;\n\n    margin-top: 50px;\n    border-bottom: solid 2px #7ecfd1;\n  }\n\n  .bottom {\n  }\n  .call-to-action {\n    margin: 10px;\n    margin-top: 20px;\n    transition: margin 300ms ease;\n    a {\n      transition: color 300ms ease;\n    }\n    border: solid 1px transparent;\n    background-color: transparent;\n  }\n  .call-to-action:not(.disable) {\n    &:hover {\n      border: solid 1px #7ecfd1;\n      border-radius: 10px;\n      background-color: #fff;\n      margin-top: 10px;\n      margin-bottom: 20px;\n    }\n  }\n'], ['\n  #contact {\n    background-image: url(', ');\n    background-position: bottom;\n    background-repeat: repeat-x;\n\n    margin-top: 50px;\n    border-bottom: solid 2px #7ecfd1;\n  }\n\n  .bottom {\n  }\n  .call-to-action {\n    margin: 10px;\n    margin-top: 20px;\n    transition: margin 300ms ease;\n    a {\n      transition: color 300ms ease;\n    }\n    border: solid 1px transparent;\n    background-color: transparent;\n  }\n  .call-to-action:not(.disable) {\n    &:hover {\n      border: solid 1px #7ecfd1;\n      border-radius: 10px;\n      background-color: #fff;\n      margin-top: 10px;\n      margin-bottom: 20px;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _frill = __webpack_require__(598);
	
	var _frill2 = _interopRequireDefault(_frill);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FooterWrapper = _styledComponents2.default.div(_templateObject, _frill2.default);
	
	var Footer = function Footer(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    FooterWrapper,
	    null,
	    _react2.default.createElement(
	      'section',
	      { id: 'contact', className: 'section is-medium has-text-centered' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column' },
	          _react2.default.createElement(
	            'p',
	            { className: 'pacifico is-size-3 has-text-primary' },
	            'Ready to build amazing things?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-6 is-3-desktop' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'call-to-action' + (location.pathname == '/contact' ? ' disable' : '')
	                },
	                location.pathname == '/contact' ? _react2.default.createElement(
	                  'p',
	                  {
	                    style: { fontFamily: 'oswald' },
	                    className: 'is-uppercase has-text-weight-bold is-size-1 is-size-2-tablet is-size-3-mobile has-text-dark'
	                  },
	                  'We Thought You Might'
	                ) : _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    style: { fontFamily: 'oswald' },
	                    to: '/contact',
	                    className: 'is-uppercase has-text-weight-bold is-size-1 is-size-2-tablet is-size-3-mobile has-text-dark'
	                  },
	                  'Get In Touch'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'bottom columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column has-text-centered has-text-primary' },
	          _react2.default.createElement(
	            'p',
	            null,
	            '\xA9 Copyright 2018 Mega House Creative Agency'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  z-index: 9000;\n  position: relative;\n\n  .headroom {\n    box-shadow: 0px 0px 0px transparent;\n    transition: box-shadow 300ms ease;\n  }\n  .headroom--pinned.headroom--scrolled {\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5);\n  }\n\n  .navbar-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .navbar-item.has-text-dark {\n    span {\n      transition: border-bottom 300ms ease;\n      border-bottom: solid 0px transparent;\n    }\n    &:hover {\n      span {\n        width: 100%;\n        border-bottom: solid 2px #9beaed;\n        transition: border-bottom 100ms cubic-bezier(0.1, 0.7, 1, 0.1);\n      }\n    }\n  }\n  .active {\n    font-weight: 500;\n    span {\n      width: 100%;\n      border-bottom: solid 2px #9beaed !important;\n    }\n  }\n'], ['\n  z-index: 9000;\n  position: relative;\n\n  .headroom {\n    box-shadow: 0px 0px 0px transparent;\n    transition: box-shadow 300ms ease;\n  }\n  .headroom--pinned.headroom--scrolled {\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5);\n  }\n\n  .navbar-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .navbar-item.has-text-dark {\n    span {\n      transition: border-bottom 300ms ease;\n      border-bottom: solid 0px transparent;\n    }\n    &:hover {\n      span {\n        width: 100%;\n        border-bottom: solid 2px #9beaed;\n        transition: border-bottom 100ms cubic-bezier(0.1, 0.7, 1, 0.1);\n      }\n    }\n  }\n  .active {\n    font-weight: 500;\n    span {\n      width: 100%;\n      border-bottom: solid 2px #9beaed !important;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(11);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHeadroom = __webpack_require__(533);
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Nav = (0, _styledComponents2.default)(_reactHeadroom2.default)(_templateObject);
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      navToggle: false
	      // this.toggle = this.toggle.bind(this)
	    };return _this;
	  }
	
	  Header.prototype.toggle = function toggle() {
	    if (this.state.navToggle == false) {
	      this.setState({
	        navToggle: true
	      });
	    } else if (this.state.navToggle == true) {
	      this.setState({
	        navToggle: false
	      });
	    } else {
	      return null;
	    }
	  };
	
	  Header.prototype.linkClick = function linkClick() {
	    this.setState({
	      navToggle: false
	    });
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var header = this.props.header;
	    return _react2.default.createElement(
	      Nav,
	      { className: '' },
	      _react2.default.createElement(
	        'nav',
	        {
	          className: 'navbar is-primary is-transparent',
	          role: 'navigation',
	          'aria-label': 'main-navigation'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'navbar-brand level is-mobile is-marginless' },
	            _react2.default.createElement(
	              'div',
	              { className: 'level-left' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: 'navbar-item level-item',
	                  to: '/',
	                  onClick: function onClick() {
	                    return _this2.linkClick();
	                  }
	                },
	                _react2.default.createElement('img', { src: header.datoCmsMenu.logo.url, alt: '' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'level-right' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: this.state.navToggle == true ? 'is-active navbar-burger level-item' : 'navbar-burger level-item',
	                  onClick: function onClick() {
	                    return _this2.toggle();
	                  }
	                },
	                _react2.default.createElement('span', null),
	                _react2.default.createElement('span', null),
	                _react2.default.createElement('span', null)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.navToggle == true ? ' is-active navbar-menu' : 'navbar-menu'
	            },
	            _react2.default.createElement('div', { className: 'navbar-start' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'navbar-end' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: (this.props.location.pathname == '/services' ? 'active ' : '') + 'navbar-item has-text-dark',
	                  to: '/services',
	                  onClick: function onClick() {
	                    return _this2.linkClick();
	                  }
	                },
	                'Services',
	                _react2.default.createElement('span', null)
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: (this.props.location.pathname == '/about' ? 'active ' : '') + 'navbar-item has-text-dark',
	                  to: '/about',
	                  onClick: function onClick() {
	                    return _this2.linkClick();
	                  }
	                },
	                'About',
	                _react2.default.createElement('span', null)
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: (this.props.location.pathname == '/work' ? 'active ' : '') + 'navbar-item has-text-dark',
	                  to: '/work',
	                  onClick: function onClick() {
	                    return _this2.linkClick();
	                  }
	                },
	                'Work',
	                _react2.default.createElement('span', null)
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: (this.props.location.pathname == '/blog' || this.props.location.pathname.match('/blog/') ? 'active ' : '') + 'navbar-item has-text-dark',
	                  to: '/blog',
	                  onClick: function onClick() {
	                    return _this2.linkClick();
	                  }
	                },
	                'Blog',
	                _react2.default.createElement('span', null)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'navbar-item' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    className: 'button is-dark',
	                    to: '/contact',
	                    onClick: function onClick() {
	                      return _this2.linkClick();
	                    }
	                  },
	                  'Contact'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(64);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbySourceDatocms = __webpack_require__(20);
	
	var _typefaceMontserrat = __webpack_require__(373);
	
	var _typefaceMontserrat2 = _interopRequireDefault(_typefaceMontserrat);
	
	var _typefaceOswald = __webpack_require__(374);
	
	var _typefaceOswald2 = _interopRequireDefault(_typefaceOswald);
	
	var _typefacePacifico = __webpack_require__(375);
	
	var _typefacePacifico2 = _interopRequireDefault(_typefacePacifico);
	
	var _header = __webpack_require__(251);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(250);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Fonts
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      data = _ref.data,
	      props = _ref.props,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: 'Mega House Creative',
	        meta: [{
	          name: 'description',
	          content: 'we provide custom, lightning fast websites designed to achieve real-world results'
	        }, {
	          name: 'keywords',
	          content: 'web development, web design, branding, marketing, websites, website, static, react, reactjs, logo design'
	        }]
	      },
	      _react2.default.createElement(
	        'script',
	        { type: 'text/javascript' },
	        '\n          {\n            (function(a,l,b,c,r,s){\n              _nQc=c,r=a.createElement(l),s=a.getElementsByTagName(l)[0];\n              r.async=1;\n              r.src=l.src=("https:"==a.location.protocol?"https://":"http://")+b;\n              s.parentNode.insertBefore(r,s);})\n              (document,"script","serve.albacross.com/track.js","89033888");\n          }\n          '
	      ),
	      _react2.default.createElement(
	        'script',
	        { type: 'text/javascript' },
	        '\n          {\n            window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||"https:"===document.location.protocol,a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=(r?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};\n              heap.load("2700195193");\n          }\n            '
	      ),
	      _react2.default.createElement(
	        'script',
	        { id: 'mcjs' },
	        '{ !function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/b385ff1132932d2efe0d96dd1/b6c7027c57b3946d23e1ac6ad.js"); }'
	      ),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/javascript' },
	        '\n    (function(b, o, n, g, s, r, c) { if (b[s]) return; b[s] = {}; b[s].scriptToken = "Xy0xMDUyODIyNDc0"; r = o.createElement(n); c = o.getElementsByTagName(n)[0]; r.async = 1; r.src = g; r.id = s + n; c.parentNode.insertBefore(r, c); })(window, document, "script", "//cdn.oribi.io/Xy0xMDUyODIyNDc0/oribi.js", "ORIBI");\n    '
	      )
	    ),
	    _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, { favicon: data.datoCmsSite.faviconMetaTags }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_header2.default, { header: data, location: location }),
	      _react2.default.createElement(
	        'div',
	        null,
	        children()
	      ),
	      _react2.default.createElement(_footer2.default, { location: location })
	    )
	  );
	};
	
	// Layout Components
	exports.default = TemplateWrapper;
	var Index = exports.Index = '** extracted graphql fragment **';

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-aee86b701160b068bc3a.js